<template>
  <li
    class="input-select__results-item py-2 px-4"
    :class="{
      'input-select__results-item--selected': isSelected,
      'input-select__results-item--focused': isFocused,
    }"
    @click="onItemSelected"
  >
    {{ getItemLabel(item) }}
  </li>
</template>

<script lang="ts">
import { toRef } from 'vue-demi';
import useItemLabel from './composables/useItemLabel';

export default defineComponent({
  props: {
    item: {
      type: [Object],
      required: true,
    },
    labelKey: {
      type: String,
      required: false,
      default: 'label',
    },
    itemLabelFn: {
      type: Function as PropType<(item: unknown) => string>,
      required: false,
      default: undefined,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isFocused: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['item-selected'],
  setup(props, { emit }) {
    const labelKeyProp = toRef(props, 'labelKey');
    const itemProp = toRef(props, 'item');
    const getItemLabel = useItemLabel<unknown>(labelKeyProp, props.itemLabelFn);

    const onItemSelected = () => {
      emit('item-selected', itemProp.value);
    };

    return { getItemLabel, onItemSelected };
  },
});
</script>

<style scoped>
.input-select__results-item:hover {
  background-color: color-mix(in srgb, var(--gp-charcoal) 90%, transparent);
  cursor: pointer;
}

.input-select__results-item--focused,
.input-select__results-item:focus {
  background-color: color-mix(in srgb, var(--gp-charcoal) 90%, transparent);
}

.input-select__results-item--selected {
  background-color: var(--gp-charcoal);
}

.input-select__results-item--selected:hover {
  background-color: var(--gp-charcoal);
  cursor: default;
}
</style>
